// ***** PMS UI *****

// Set in the UI Used so that we can extend or shorten PMS if needed
export const pmsSteps = [
  {
    label: "Your Details",
    value: 1,
  },
  {
    label: "Symptoms",
    value: 2,
  },
  {
    label: "Preferences",
    value: 3,
  },
  {
    label: "Session Details",
    value: 4,
  },

  {
    label: "Medical",
    value: 5,
  },
  {
    label: "Payment",
    value: 6,
  },
];

export const pmsFormHeaders = [
  {
    image: "/images/illustrations/search.png",
    title: "Your details",
    description: " Get started on your MatchPlus details!",
  },
  {
    image: "/images/PMS/form.jpg",
    title: "What's worrying you?",
    description: "What's worrying you?",
  },
  {
    image: "/images/illustrations/search.png",
    title: "Preferences",
    description: "Your preferences help to find a great match.",
  },
  {
    image: "/images/illustrations/search.png",
    title: "Session details",
    description: "What kind of session would you prefer?",
  },

  {
    image: "/images/illustrations/search.png",
    title: "Medical details",
    description: "Anything specific our therapists should know about?",
  },
  {
    image: "/images/illustrations/search.png",
    title: "Payment",
    description: "",
  },
];
